import { PhysicalStoreCartResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class PhysicalStoreCart<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Gets a list of all physical stores and states for the cart.
	 *
	 * @tags PhysicalStoreCart
	 * @name GetPhysicalStores
	 * @summary Retrieves physical stores and states for the cart.
	 * @request GET:/store/{storeId}/hdm/shopcart/physicalstore
	 * @response `200` `PhysicalStoreCartResponse` Successful response with physical stores and state list.
	 * @response `400` `void` Invalid parameters.
	 * @response `404` `void` No stores found for the specified cart/store.
	 * @response `500` `void` Internal server error.
	 */
	getPhysicalStores = (
		storeId: string,
		query: {
			/**
			 * @default "json"
			 * @example "json"
			 */
			responseFormat: 'json' | 'xml';
			/** @example "-5" */
			langId: string;
			/** @example "62397829" */
			orderId: string;
			/** @example "transferCartPopup_stores" */
			fromPage?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['getPhysicalStores'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/shopcart/physicalstore`,
				params: _params,
				query: query,
				methodName: 'getPhysicalStores',
			};
			logger.trace(traceData);
		}
		return this.http.request<PhysicalStoreCartResponse, void>({
			path: `/store/${storeId}/hdm/shopcart/physicalstore`,
			method: 'GET',
			query: query,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
